export class QuillUtils {
    createBackDrop() {
        var cover = document.createElement("div");
        cover.style.height = "100%";
        cover.style.width = "100%";
        cover.style.backgroundColor = "black";
        cover.style.opacity = "0.6";
        cover.style.position = "absolute";
        cover.style.top = "0px";
        cover.style.left = "0px";
        cover.style.zIndex = "1";
        cover.appendChild(this.createWaiting());
        return cover;
    }

    createWaiting() {
        var node = document.createElement("div");
        node.style.position = "absolute";
        node.style.display = "flex";
        node.style.width = "100%";
        node.style.height = "100%";
        node.style.justifyContent = "center";
        node.style.alignItems = "center";
        node.style.zIndex = "10";
        node.appendChild(this.createWaitingMessage());
        return node;
    }

    createWaitingMessage() {
        var node = document.createElement("div");
        node.style.color = "black";
        node.style.backgroundColor = "white";
        node.style.padding = "20px";
        node.innerHTML = "Aguarde...";
        return node;
    }
}

